import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { AchievementsActionType, AchievementsStore, BaseAchievementElement } from './AchievementsReducer.types';

// @ts-ignore
export const initialState: AchievementsStore = Immutable.fromJS({
  all: [],
  completed: [],
  incomplete: [],
  filter: 'all',
  isFetching: false,
});

const AchievementsReducer = handleActions<any>(
  {
    ACHIEVEMENTS_REQUEST: (state: AchievementsStore) => state.set('isFetching', true),

    ACHIEVEMENTS_RESPONSE_FAILURE: (state: AchievementsStore) => state.set('isFetching', false),
    ACHIEVEMENTS_RESPONSE: (state: AchievementsStore, action: AchievementsActionType) => {
      const completed = action.payload.data.filter((item: BaseAchievementElement) => item.achieved !== null);
      const incomplete = action.payload.data.filter((item: BaseAchievementElement) => item.achieved === null);

      return state
        .set('isFetching', false)
        .set('all', Immutable.fromJS(action.payload.data))
        .set('completed', Immutable.fromJS(completed))
        .set('incomplete', Immutable.fromJS(incomplete));
    },
    CHANGE_ACHIEVEMENTS_FILTER: (state: AchievementsStore, action: AchievementsActionType) => state.set('filter', action.payload),
    AUTHENTICATION_LOGOUT: () => initialState,
  },
  initialState
);

export default AchievementsReducer;
